import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
declare var $: any;
@Component({
  selector: 'app-edit-animal-vaccine',
  templateUrl: './edit-animal-vaccine.component.html',
  styleUrls: ['./edit-animal-vaccine.component.css']
})
export class EditAnimalVaccineComponent implements OnInit {
  returnUrl="/dashboard/RottweilerDogsAnimalmanagement";
    vaccine_name:any;
  batch_no:any;
  expiry_date:any;
  dose_value:any;
  units:any;
  vaccine_date1:any;
  remark:any;

  getvaccineeditApi:any;
  putvaccineeditApi:any;
  // getvaccineeditApi:any;
  // putvaccineeditApi:any;
  EditVaccineFormValue:any;
  getVaccineListData:any;
  getlistApi:any;
  loginresponse:any;
  cby_mby:any;
  addUrl:any;
  constructor(private router: Router,private commonService:CommonService) { }

  async ngOnInit() {
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby=this.loginresponse.user_id;
    $('.selectpicker').selectpicker('refresh'); 
    let VaccineId = sessionStorage.getItem('vaccineId');
    this.getvaccineeditApi= "/animal_management/vaccine/"+ VaccineId;
    this.putvaccineeditApi= "/animal_management/vaccine/"+ VaccineId;
    (await this.commonService.getApi(this.getvaccineeditApi)). subscribe(
      async  (res:any) => {
        this.getlistApi= "/vaccine";
        (await this.commonService.getApi(this.getlistApi)).subscribe(
          async (res) => {
            this.getVaccineListData = res.data;
          })
         var date=res.data.tnam_vac_date_of_first_vaccine;
         var testdate = date.split('T');
        //  var date1=res.data.tnam_vac_date_of_second_vaccine;
        //  var testdate1 = date1.split('T');
         var date=res.data.tnam_vac_expiry_date;
         var testdate2 = date.split('T');
        $("#ExpiryDate").val(testdate2[0])       
         $("#ExpiryDate").text(testdate2[0])
         $("#vaccinename").val(res.data.tnam_vac_vaccine_name)
         $("#batchNumber").val(res.data.tnam_vac_batch_number)
        $("#VaccineDate1").val(testdate[0])   
        // $("#VaccineDate2").val(testdate1[0])    
        $("#remark").val(res.data.tnam_vac_date_of_second_vaccine)  
         $("#dosevalue").val(res.data.tnam_vac_dose_value)
         $("#unit").val(res.data.tnam_vac_units);
         setTimeout(()=>{
          $("select[name=VaccineName]").val(res.data.tnam_vac_vaccine_name)
          $("#VaccineName .filter-option").text(res.data.vaccine_name)
          $('.selectpicker').selectpicker('refresh'); 
         },1000)
        })
  }
  async AnimalVaccine(){
    var farmid=sessionStorage.getItem('farmid');
    var Animalid=sessionStorage.getItem('animalid');
    var speciesid=sessionStorage.getItem('speciesid');
    var breedid=sessionStorage.getItem('breedid');
    var ageid=sessionStorage.getItem('ageid');
    this.EditVaccineFormValue = {
      "species_id":speciesid,
   "breed_id":breedid,
    "farm_id":farmid,
  "animal_code":Animalid,
    "vaccine_name":$("#vaccinename").val(),
    "batch_number":$("#batchNumber").val(),
    "expiry_date":$("#ExpiryDate").val(),
    "dose_value":$("#dosevalue").val(),
   "age_group":ageid,
    "units":$("#unit").val(),
    "date_of_first_vaccine":$("#VaccineDate1").val(),
    "date_of_second_vaccine":$("#remark").val(),
    "cby":this.cby_mby,
    "mby":this.cby_mby,
    "status": 1,
    "is_active": 1
     };
       (await this.commonService.putApi( this.putvaccineeditApi,this.EditVaccineFormValue)).subscribe(
         data => {
             alert("Data edited successfully");
         });
         setTimeout(
          () : void => {
    
            this.router.navigate([this.returnUrl]);
    
          },
          500
        );
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
